export const Squiggle = ({ className = "" }) => (
  <svg
    className={className}
    width="100%"
    height="100%"
    viewBox="0 0 100 1000"
    preserveAspectRatio="none"
    aria-hidden="true"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="squiggle-grad" x1="0" y1="0" x2="0" y2="1000" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00C6A9" />
        <stop offset="42%" stopColor="#00AF95" />
        <stop offset="49%" stopColor="#63B784" />
        <stop offset="55%" stopColor="#FFB4A6" />
        <stop offset="72%" stopColor="#FFA595" />
        <stop offset="100%" stopColor="#FF9E8D" />
      </linearGradient>
    </defs>
    <path
      d="M 26 -40
         C 92 70, 98 150, 46 166
         C 4 179, 2 252, 54 260
         C 90 266, 86 362, 44 380
         C 6 398, 12 520, 56 558
         C 98 588, 100 682, 48 692
         C 8 702, 14 612, 46 602
         C 76 594, 88 782, 46 814
         C 14 842, 22 942, 64 952
         C 98 960, 82 1052, 42 1075"
      stroke="url(#squiggle-grad)"
      strokeWidth="64"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
      opacity="1"
    />
  </svg>
);
